<template>
  <AppLink
    :text="text"
    :type-classes="typeClasses"
    :icon-classes="iconClasses"
    :type-styles="typeStyles"
    :href="finalUrl"
    :disabled="disabled"
    :title="title"
    :always-show-tooltip="alwaysShowTooltip"
    :tooltip-placement="tooltipPlacement"
  ></AppLink>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'ReportLink',
  props: {
    text: { type: String, required: true },
    url: { type: String },
    type: { type: String },
    typeClasses: { type: String },
    typeStyles: { type: String },
    iconClasses: { type: String },
    options: { type: Object, default: () => ({}) },
    disabled: { type: Boolean, default: false },
    title: { type: String },
    alwaysShowTooltip: { type: Boolean, default: false },
    tooltipPlacement: { type: String },
  },
  computed: {
    finalUrl() {
      const params = { ...this.$store.state.report_query, ...this.options };
      let url = this.url || this.getReportUrl;

      if (this.type) {
        url += '.' + this.type;
      }
      url += '?' + $.param(params);

      return url;
    },
    ...mapGetters(['getReportUrl']),
  },
};
</script>
